module.exports = __webpack_public_path__ + "static/media/18ECA26.173818be.jpg";